import axios from "axios"
import React, { useState } from "react"
import "../App.css"
import { SERVER_URI } from "../utility/config"
import LoginRequest from "./LoginRequest"

function MaxPassengerCountCreatedMessage(props) {
	window.setTimeout(function () {
		// Move to a new location
		props.handleClose()
	}, 1700)
	return (
		<div>
			<h2 className="message_title">Maksimi matkustajamäärä asetettu</h2>
		</div>
	)
}

function SetMaxPassengerCount(props) {
	const [show, setShow] = useState(false)
	const [userData, setUserData] = useState({
		maxPassengerCount: props.currentMaxPassengerCount,
	})
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")

	//Look at this closer

	const onChange = (e) => {
		setUserData({ ...userData, [e.target.name]: e.target.value })
	}

	// Submit
	const doSubmit = async (e) => {
		e.preventDefault()
		const dataToServer = userData
		try {
			await axios.put(`${SERVER_URI}/set_max_passenger_count/`, dataToServer, {
				headers: { Authorization: `Token ${userToken}` },
			})
			props.dispatch({
				type: "UPDATE_MAX_PASSENGER_COUNT",
				data: { newMaxPassengerCount: dataToServer.maxPassengerCount },
			})
			setShow(!show)
		} catch (e) {
			console.log("Error in setting max passenger count.", e)
		}
	}
	return (
		<div className="popUp_card">
			<div className="popup-box">
				<div className="box">
					<span className="close-icon" onClick={props.handleClose}>
						x
					</span>
					{!show && (
						<div>
							<h2 className="popUp_title">Aseta maksimi matkustajamäärä </h2>
							<form className="rejectionReason_form" onSubmit={(e) => doSubmit(e)}>
								<label className="label_add" htmlFor="rejectReason">
									Matkustajamäärä:
								</label>
								<input
									id="rejectReason"
									name="maxPassengerCount"
									onChange={onChange}
									value={userData.maxPassengerCount}
									required></input>{" "}
								<br className="desktop-break" />
								<input type="submit" id="gradient_Button" value="Aseta matkustajamäärä" />
							</form>
						</div>
					)}
					{show && <MaxPassengerCountCreatedMessage handleClose={props.handleClose} />}
				</div>
			</div>
		</div>
	)
}

function MaxPassengerCount(props) {
	props.stopListRefresh()
	const [isOpen, setIsOpen] = useState(false)
	//const [isloggedIn, setIsloggedIn] = useState(true);
	//let storage = window.localStorage;
	//let userToken = storage.getItem("admin_token")

	/* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

	const togglePopUp = async () => {
		setIsOpen(!isOpen)
	}

	return (
		<div className="configurations">
			{isOpen && <SetMaxPassengerCount dispatch={props.dispatch} currentMaxPassengerCount={props.maxPassengerCount} handleClose={togglePopUp} />}
			<h3>Maksimi matkustajamäärä</h3>
			<div className="rides">
				{props.maxPassengerCount === undefined ? (
					<LoginRequest />
				) : props.maxPassengerCount.length === 0 ? (
					<h4>Maksimi matkustajamäärää ei ole asetettu</h4>
				) : (
					<div className="customer_list">
						{props.maxPassengerCount}
						<br />
					</div>
				)}
			</div>
			<button id="gradient_Button" onClick={togglePopUp}>
				Aseta maksimi matkustajamäärä
			</button>
		</div>
	)
}

export default MaxPassengerCount
